// extracted by mini-css-extract-plugin
export default {"root":"calendar_display-module___root___bbdfd7d5"};